import {FiltroModel} from './feature-filtro.model';
import {Action, createReducer, on} from '@ngrx/store';
import {filtroReiniciar, filtroSetInput} from './feature-filtro.actions';

const initialState: FiltroModel = {filtros: []};

const reducer = createReducer(
  initialState,
  on(filtroSetInput, (state, {filtros}) => ({...state, filtros})),
  on(filtroReiniciar, () => (initialState))
);

export const featureFiltroRecucer = (state: FiltroModel, action: Action) => reducer(state, action);
